import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from './plugins/firebase'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { required, email, max, numeric, size } from 'vee-validate/dist/rules'
import VModal from 'vue-js-modal'
import InfiniteLoading from 'vue-infinite-loading'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { sync } from 'vuex-router-sync'
import UUID from 'vue-uuid'

const unsync = sync(store, router)
unsync()

require('@/assets/css/style.sass')

const moment = require('moment')
require('moment/locale/ja')

extend('required', {
  ...required,
  message: 'エラー：必須項目です'
})
extend('email', {
  ...email,
  message: 'エラー：メールの形式ではありません'
})
extend('max', {
  ...max,
  message: 'エラー：文字数の上限を超えています'
})
extend('numeric', {
  ...numeric,
  message: 'エラー：数字以外の文字が含まれています'
})
extend('size', {
  ...size,
  message: 'エラー：700KB以内にしてください'
})

Vue.use(firebase)
Vue.config.productionTip = false
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(require('vue-moment'), {
  moment
})
library.add(fas, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueAxios, axios)
Vue.use(VModal)
Vue.use(InfiniteLoading)
Vue.use(UUID)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
